import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    milestoneFull: 'b-brand-2 bg-brand-2',
    milestoneBar: 'bg-brand-2'
  },
} satisfies RecursivePartial<VfConfig['milestoneBar']>
